import { createApp } from "vue";
import App from "./App.vue";
import "./style.css";
import { vueUi } from "./ui/vueUi";

createApp(App).use(vueUi).mount("#app");
